import type {ActionsObservable} from 'redux-observable';
import {Observable} from 'rxjs';
import {switchMap, filter, map, catchError} from 'rxjs/operators';

import {transformDataForReport} from 'nutshell-core/json-to-report-data';

import type {SMSReportDataRequestedAction} from '../types';
// @ts-expect-error
import {getReportPostParams, ReportPostParams} from '../utils';

import {updateReportChartData, failReportChartData} from './sms-actions';

export const requestSMSReportDataEpic = (action$: ActionsObservable<any>) =>
    action$.ofType('SMS_REPORT_DATA_REQUESTED').pipe(
        switchMap((action: SMSReportDataRequestedAction) => {
            const {reportParams, filters} = action.payload;
            const params = getReportPostParams(reportParams, filters);
            const requestStream = Observable.from(fetchData(params));
            const reportDataStream = requestStream.pipe(map(transformDataForReport));

            const reportChartDataStream = reportDataStream.pipe(
                map((data) => data.chartData),
                filter((chartData) => Boolean(chartData)),
                map((chartData) => updateReportChartData({chartData}))
            );

            return reportChartDataStream.pipe(
                catchError((err) => Observable.of(failReportChartData(err)))
            );
        })
    );

function fetchData(params: ReportPostParams) {
    return Promise.all([fetchSMSReportData(params)]);
}

function fetchSMSReportData(params: ReportPostParams): Promise<any> {
    const url = '/rest/inboxes/report';
    const ajaxParams = {
        url,
        dataType: 'json',
        data: params,
    } as const;

    return $.ajax(ajaxParams) as any; // This is how we have to convince flow that the response is a ReportsResponse
}
